import React, { useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import styles from './TabContainer.module.scss';
import cx from 'classnames';
import { HorizontalScrollIndicator } from '../_shared';

const TabContainer = (props) => {
    const { children, label } = props;

    const tabListRef = useRef();

    const scrollableElement = () => tabListRef.current.querySelector('.rwc-cnt');

    return (
        <div className={cx('tabs-wrapper', styles.root)}>
            <div
                aria-label={label}
                className={cx('tab-container', styles.tablist)}
                id={uuidv4()}
                role="tablist"
                ref={tabListRef}
            >
                <HorizontalScrollIndicator
                    direction={'left'}
                    containerElement={scrollableElement}
                />
                {children}
                <HorizontalScrollIndicator
                    direction={'right'}
                    containerElement={scrollableElement}
                />
            </div>
            <div className={cx('tab-panels-container')} />
        </div>
    );
};

TabContainer.displayName = 'TabContainer';

TabContainer.propTypes = {
    label: PropTypes.string.isRequired,
};

export default TabContainer;
